import { render, staticRenderFns } from "./UserPortalNavbar.vue?vue&type=template&id=2eb99584&"
import script from "./UserPortalNavbar.vue?vue&type=script&lang=js&"
export * from "./UserPortalNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports